import React from 'react';
import PropTypes from 'prop-types';

import { formatDate } from '_utils';
import { licensePoolPropType, getLicensePoolStatusLabel, getLicensePoolExpiresOnLabel, getLicensePoolTypeLabel } from '_utils/licensePools';

import {
  Segment
} from 'semantic-ui-react';
import LineItem from '_views/lineItem';

const ACLicensePoolInfo = ({
  licensePool
}) => {
  return (
    <Segment>
      <LineItem label="Type" text={ getLicensePoolTypeLabel(licensePool) } />
      <LineItem label="Created On" text={ formatDate(licensePool.created_on) } />
      <LineItem label="Expires On" text={ getLicensePoolExpiresOnLabel(licensePool) } />
      <LineItem label="Status" text={ getLicensePoolStatusLabel(licensePool) } />
      <LineItem label='Description' text={ licensePool.description || "" } />
      <LineItem label='ID' text={ licensePool._id } />
    </Segment>
  );
};

ACLicensePoolInfo.propTypes = {
  licensePool: PropTypes.arrayOf(licensePoolPropType).isRequired
};

export default ACLicensePoolInfo;



// WEBPACK FOOTER //
// ./webAdmin/views/activationCodes/licensePoolInfo.js